// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"d1dc9c9d","239":"da2da693","732":"124c0c08","977":"73360b8a"}[chunkId] + ".chunk.js";
};